import {MaintenanceCategory} from "@/models/maintenance/MaintenanceCategory";
import {ValidationObserver, ValidationProvider} from "vee-validate";
export default {
  name: "MaintenanceCategoriesDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isAdd: false,
      isUpdate: false,
      maintenanceCategory: new MaintenanceCategory()
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
  },
  methods: {
    open(action: string, maintenanceCategory: MaintenanceCategory) {
      this.dialog = true;

      if (action === "add") {
        this.isAdd = true;
      }

      if (action === "update") {
        this.isUpdate = true;
        this.maintenanceCategory = new MaintenanceCategory(maintenanceCategory.name, maintenanceCategory.facilityId, maintenanceCategory.id);
      }
    },
    close() {
      this.dialog = false;
      this.maintenanceCategory.clear()
      this.isAdd = false;
      this.isUpdate = false;
    },
    async submit() {
      this.loading = true;

      if (this.isAdd) {
        await this.addMaintenanceCategory();
      }

      if (this.isUpdate) {
        await this.updateMaintenanceCategory();
      }

      this.close();
    },
    async addMaintenanceCategory() {
      const maintenanceCategory = Object.assign({}, this.maintenanceCategory);
      maintenanceCategory.facilityId = this.facilityId;
      delete maintenanceCategory.id;

      console.log("ADD NEW ", maintenanceCategory)

      await this.$store.dispatch("createMaintenanceCategory", maintenanceCategory)
        .then(() => {
          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceManagement.MaintenanceCategorySuccessAdded")
          });

          this.close();
        }).catch((error) => {
          this.$toast.open({
            type: "error",
            message: error.message
          });
        }).finally(() => {
          this.loading = false;
        });
    },
    async updateMaintenanceCategory() {
      const maintenanceCategory = Object.assign({}, this.maintenanceCategory);

      this.$store.dispatch("updateMaintenanceCategory", maintenanceCategory)
        .then(async () => {
          await this.$store.dispatch("updateMaintenanceCategoryForSelectedCollection", { collection: "vendors", maintenanceCategory: maintenanceCategory });
          await this.$store.dispatch("updateMaintenanceCategoryForSelectedCollection", { collection: "maintenanceScheduled", maintenanceCategory: maintenanceCategory });
          await this.$store.dispatch("updateMaintenanceCategoryForSelectedCollection", { collection: "maintenanceRequests", maintenanceCategory: maintenanceCategory });

          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceManagement.MaintenanceCategorySuccessUpdated")
          });
          this.close();
        }).catch((error) => {
          this.$toast.open({
            type: "error",
            message: error.message
          })
        }).finally(() => {
          this.loading = false;
        });
    }
  }
}